import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { INDEX_ENTRIES } from "../data/bookContent";

export default function IndexPage({ onJump }) {
  const grouped = useMemo(() => {
    const g = {};
    for (const e of INDEX_ENTRIES) {
      const letter = e.term[0].toUpperCase();
      if (!g[letter]) g[letter] = [];
      g[letter].push(e);
    }
    for (const k of Object.keys(g)) g[k].sort((a, b) => a.term.localeCompare(b.term));
    return g;
  }, []);
  const letters = Object.keys(grouped).sort();

  return (
    <div className="book-page max-w-3xl mx-auto px-6 sm:px-12 py-10 sm:py-14" data-testid="index-page">
      <div className="flex items-baseline justify-between border-b border-magenta-400/20 pb-4 mb-8" style={{ borderColor: "rgba(255,60,126,0.25)" }}>
        <h2 className="font-display text-4xl sm:text-5xl font-extrabold text-white">
          Index
        </h2>
        <span className="text-slate-500 font-heading uppercase text-xs tracking-widest">
          Tap a term to jump
        </span>
      </div>

      <div className="grid sm:grid-cols-2 gap-x-10 gap-y-8">
        {letters.map((L, idx) => (
          <motion.div
            key={L}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.05 }}
          >
            <div className="font-display text-2xl font-extrabold neon-magenta mb-3">{L}</div>
            <ul className="space-y-1.5">
              {grouped[L].map((e) => (
                <li key={e.term}>
                  <button
                    onClick={() => onJump(e.chapterId)}
                    data-testid={`index-term-${e.chapterId}-${e.term.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                    className="text-left w-full text-slate-200 hover:text-cyan-300 hover:pl-2 transition-all font-body text-sm sm:text-base"
                  >
                    {e.term}
                    <span className="text-slate-600 text-xs ml-2">→</span>
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
